<template>
  <el-dialog
    title="欢迎登录"
    v-model="visible"
    width="500px"
    :before-close="handleClose"
    :close-on-click-modal="true"
    :show-close="true"
    class="login-dialog"
  >
    <div class="login-content">
      <el-form
        ref="loginForm"
        :model="loginData"
        :rules="loginRules"
        label-width="0px"
        class="login-form"
      >
        <!-- 只保留学生登录，移除教师登录选项 -->
        <!-- <div class="login-title">
          <h3>学生登录</h3>
        </div> -->

        <el-form-item prop="username">
          <el-input
            v-model="loginData.username"
            placeholder="请输入用户名"
            prefix-icon="el-icon-user"
            size="large"
          />
        </el-form-item>

        <el-form-item prop="password">
          <el-input
            v-model="loginData.password"
            type="password"
            placeholder="请输入密码"
            prefix-icon="el-icon-lock"
            size="large"
            show-password
            @keyup.enter.native="handleLogin"
          />
        </el-form-item>

        <el-form-item>
          <el-checkbox v-model="loginData.rememberMe">记住密码</el-checkbox>
        </el-form-item>

        <el-form-item>
          <el-button
            type="primary"
            size="large"
            :loading="loading"
            @click="handleLogin"
            class="login-btn"
          >
            登录
          </el-button>
        </el-form-item>
      </el-form>
    </div>
  </el-dialog>
</template>

<script>
import { teachStudentLogin } from "@/api/index.js";

export default {
  name: "LoginDialog",
  props: {
    value: {
      type: Boolean,
      default: false
    },
    modelValue: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      visible: this.value || this.modelValue,
      userType: 'student', // 固定为学生登录
      loading: false,
      loginData: {
        username: '',
        password: '',
        rememberMe: false
      },
      loginRules: {
        username: [
          { required: true, message: '请输入用户名', trigger: 'blur' },
          { min: 4, max: 50, message: '用户名长度为 4-50 位', trigger: 'blur' },
          { pattern: /^[\u4e00-\u9fa5a-zA-Z0-9_-]+$/, message: '用户名由汉字、字母、数字、下划线、连字符组成', trigger: 'blur' }
        ],
        password: [
          { required: true, message: '请输入密码', trigger: 'blur' },
          { min: 4, max: 16, message: '密码长度为 4-16 位', trigger: 'blur' }
        ]
      }
    };
  },
  watch: {
    value(newVal) {
      this.visible = newVal;
    },
    modelValue(newVal) {
      this.visible = newVal;
    },
    visible(newVal) {
      if (!newVal) {
        this.$emit('update:modelValue', false);
        this.$emit('update:value', false);
        this.$emit('input', false);
        this.$emit('close');
      } else {
        this.$emit('update:modelValue', true);
        this.$emit('input', true);
        this.$emit('update:value', true);
      }
    }
  },
  methods: {
    // 移除教师登录切换功能，固定为学生登录
    
    handleLogin() {
      this.$refs.loginForm.validate((valid) => {
        if (valid) {
          this.loading = true;
          
          // 构建登录数据，固定为学生类型
          const loginRequest = {
            username: this.loginData.username.trim(),
            password: this.loginData.password,
            userType: 'student'  // 固定为学生
          };
          
          // 固定为学生类型：2
          const numericUserType = 2;
          
          teachStudentLogin(loginRequest).then((res) => {
            if (res.data && res.data.accessToken) {
              // 通过Vuex action保存登录状态（包含localStorage）
              this.$store.dispatch('login', {
                token: res.data.accessToken,
                refreshToken: res.data.refreshToken,
                userType: numericUserType, // 固定为学生类型：2
                userId: res.data.userId,
                tenantId: res.data.tenantId,
                userInfo: res.data.user || {}
              });
              
              // 如果选择记住密码，保存到localStorage
              if (this.loginData.rememberMe) {
                localStorage.setItem('loginData', JSON.stringify({
                  username: this.loginData.username,
                  password: this.loginData.password,
                  userType: numericUserType // 固定为学生类型：2
                }));
              } else {
                localStorage.removeItem('loginData');
              }
              
              this.$message.success('登录成功');
              this.handleClose();
              
              // 触发登录成功事件，让App.vue处理跳转
              this.$emit('login-success', {
                token: res.data.accessToken,
                refreshToken: res.data.refreshToken,
                userId: res.data.userId,
                tenantId: res.data.tenantId,
                userType: numericUserType // 固定为学生类型：2
              });
              
            } else {
              this.$message.error('登录失败，请检查用户名和密码');
            }
          }).catch((error) => {
            console.error('登录失败:', error);
            // 根据错误信息给出更具体的提示
            if (error.response && error.response.data && error.response.data.msg) {
              this.$message.error(error.response.data.msg);
            } else {
              this.$message.error('登录失败，请检查用户名和密码');
            }
          }).finally(() => {
            this.loading = false;
          });
        }
      });
    },
    
    handleClose() {
      this.visible = false;
      this.$emit('update:modelValue', false);
      this.$emit('update:value', false);
      this.$emit('input', false);
      this.$emit('close');
      // 重置表单
      this.loginData = {
        username: '',
        password: '',
        rememberMe: false
      };
      this.userType = 'student';
      this.$refs.loginForm && this.$refs.loginForm.resetFields();
    }
  },
  
  mounted() {
    // 检查是否有保存的登录信息
    const savedLoginData = localStorage.getItem('loginData');
    if (savedLoginData) {
      try {
        const data = JSON.parse(savedLoginData);
        this.loginData.username = data.username;
        this.loginData.password = data.password;
        this.loginData.rememberMe = true;
        // 固定为学生类型
        this.userType = 'student';
      } catch (error) {
        console.error('解析保存的登录信息失败:', error);
      }
    }
  }
};
</script>

<style scoped lang="scss">
.login-dialog {
  .login-content {
    padding: 20px 0;
  }
  
  .user-type-switch {
    display: flex;
    justify-content: center;
    margin-bottom: 30px;
    gap: 20px;
    
    .type-btn {
      width: 120px;
      height: 40px;
      border-radius: 20px;
      font-size: 16px;
      transition: all 0.3s ease;
    }
  }
  
  .login-form {
    .el-form-item {
      margin-bottom: 20px;
    }
    
    .el-input {
      height: 45px;
      
      :deep(.el-input__inner ){
        height: 45px;
        line-height: 45px;
        border-radius: 8px;
        font-size: 16px;
      }
    }
    
    .login-btn {
      width: 100%;
      height: 45px;
      border-radius: 8px;
      font-size: 18px;
      font-weight: 600;
      margin-top: 10px;
    }
  }
}

:deep(.el-dialog ){
  border-radius: 15px;
  overflow: hidden;
}

:deep(.el-dialog__header ){
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  color: white;
  padding: 20px;
  text-align: center;
  
  .el-dialog__title {
    font-size: 20px;
    font-weight: 600;
  }
  
  .el-dialog__close {
    color: white;
    font-size: 18px;
    
    &:hover {
      color: #f0f0f0;
    }
  }
}

:deep(.el-dialog__body ){
  padding: 30px 40px;
}

@media (max-width: 600px) {
  :deep(.el-dialog) {
    width: 92% !important;
    margin: 0 auto !important;
  }

  :deep(.el-dialog__header) {
    padding: 16px;
  }

  :deep(.el-dialog__body) {
    padding: 20px 16px;
  }

  .login-form {
    .el-input {
      height: 44px;

      :deep(.el-input__inner) {
        height: 44px;
        line-height: 44px;
        font-size: 15px;
      }
    }

    .login-btn {
      height: 44px;
      font-size: 16px;
    }
  }
}
</style>